/*       */

import { gql } from '@apollo/client';

export default gql`
    query designerScriptListQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "system_hook_action", filterBy: $filterBy, excludeBy: $excludeBy)
        records: entities(type: "system_hook_action", startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            iconName
            iconColor
            iconType
            primary(fields: ["version"])
            modifiedDate
            createdDate
            createdBy {
                id
                name
            }
            modifiedBy {
                id
                name
            }
        }
    }
`;
